export default __webpack_public_path__ + "static/media/DSCN0379.484c4bd6.JPG";